module.exports = __webpack_public_path__ + "static/media/cross_arm_clamp.7f827def.webp";